import React from "react";
import { ThemeProvider, createTheme } from "mui/styles";
import CssBaseline from "mui/CssBaseline";
import baseTheme from "assets/theme";

const orangeTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: "#ff9800",
      focus: "#ff9800",
    },
  },
});

const ModeratorThemeProvider = ({ children }) => (
  <ThemeProvider theme={orangeTheme}>
    <CssBaseline />
    <div style={{ "--primary-color": "#ff9800", "--primary-text-color": "#fff" }}>
      {children}
    </div>
  </ThemeProvider>
);

export default ModeratorThemeProvider;
